<script>
import { mapGetters } from "vuex";

export default {
  name: "PromoPlanCellRenderer",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      selectedProperty: "revManStore/getSelectedProperty",
      propertyPromotionSettings: "revManStore/getPropertyPromotionSettings",
    }),

    cellValue() {
      return this.params?.value;
    },
    hasCellValue() {
      return (
        this.selectedProperty &&
        // this.propertyPromotionSettings?.automation_enabled_by_admin &&
        this.cellValue &&
        Object.keys(this.cellValue).length
      );
    },
    isPromoPlan() {
      return (
        this.cellValue &&
        this.cellValue?.type &&
        this.cellValue?.type === "promotion plan"
      );
    },
    showCellInfo() {
      return (
        (this.hasCellValue &&
          this.params?.viewPermission &&
          this.isPromoPlan) ||
        (this.hasCellValue && !this.isPromoPlan)
      );
    },
  },
};
</script>

<template>
  <div v-if="showCellInfo">
    <span class="pr-1">
      <svg
        v-if="isPromoPlan"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        class="mb-n1"
      >
        <path
          d="M7.99967 14.6666C6.86836 14.6666 5.82796 14.409 4.87846 13.8939C3.92897 13.3787 3.15119 12.6918 2.54513 11.8333V13.4545H1.33301V9.8181H4.96937V11.0302H3.46937C3.95422 11.7575 4.59311 12.3434 5.38604 12.7878C6.17897 13.2322 7.05018 13.4545 7.99967 13.4545C8.75725 13.4545 9.46685 13.3105 10.1285 13.0226C10.7901 12.7348 11.3658 12.3459 11.8557 11.856C12.3456 11.3661 12.7345 10.7903 13.0224 10.1287C13.3103 9.46709 13.4542 8.75749 13.4542 7.99992H14.6663C14.6663 8.91911 14.4921 9.78275 14.1436 10.5908C13.7951 11.3989 13.3179 12.106 12.7118 12.712C12.1057 13.3181 11.3987 13.7954 10.5906 14.1439C9.7825 14.4923 8.91887 14.6666 7.99967 14.6666ZM7.45422 12.2423V11.4545C6.97947 11.3434 6.59311 11.1388 6.29513 10.8408C5.99715 10.5428 5.77745 10.1514 5.63604 9.66658L6.63604 9.27265C6.75725 9.68679 6.94664 9.99739 7.20422 10.2045C7.4618 10.4115 7.75725 10.5151 8.09058 10.5151C8.42392 10.5151 8.70927 10.4368 8.94664 10.2802C9.18402 10.1237 9.3027 9.87871 9.3027 9.54537C9.3027 9.25244 9.17897 9.01507 8.93149 8.83325C8.68402 8.65143 8.2421 8.44436 7.60573 8.21204C7.00978 7.99992 6.57291 7.74739 6.29513 7.45446C6.01735 7.16153 5.87846 6.7777 5.87846 6.30295C5.87846 5.88881 6.0224 5.51254 6.31028 5.17416C6.59816 4.83578 6.98957 4.61608 7.48452 4.51507V3.75749H8.54513V4.51507C8.90877 4.54537 9.23957 4.69184 9.53755 4.95446C9.83553 5.21709 10.0401 5.52517 10.1512 5.87871L9.18149 6.27265C9.10068 6.04032 8.96937 5.84588 8.78755 5.68931C8.60573 5.53275 8.35321 5.45446 8.02998 5.45446C7.67644 5.45446 7.40624 5.53022 7.21937 5.68174C7.0325 5.83325 6.93907 6.04032 6.93907 6.30295C6.93907 6.56557 7.05523 6.77265 7.28755 6.92416C7.51988 7.07568 7.93907 7.25244 8.54513 7.45446C9.2724 7.71709 9.75725 8.02517 9.99967 8.37871C10.2421 8.73224 10.3633 9.12113 10.3633 9.54537C10.3633 9.8383 10.3128 10.0959 10.2118 10.3181C10.1108 10.5403 9.97695 10.7297 9.81028 10.8863C9.64361 11.0428 9.44917 11.1691 9.22695 11.2651C9.00472 11.361 8.76735 11.4343 8.51483 11.4848V12.2423H7.45422ZM1.33301 7.99992C1.33301 7.08073 1.50725 6.21709 1.85574 5.40901C2.20422 4.60093 2.68149 3.89386 3.28755 3.2878C3.89361 2.68174 4.60068 2.20446 5.40876 1.85598C6.21685 1.50749 7.08048 1.33325 7.99967 1.33325C9.13099 1.33325 10.1714 1.59083 11.1209 2.10598C12.0704 2.62113 12.8482 3.308 13.4542 4.16659V2.54537H14.6663V6.18174H11.03V4.96962H12.53C12.0451 4.24234 11.4062 3.65648 10.6133 3.21204C9.82038 2.7676 8.94917 2.54537 7.99967 2.54537C7.2421 2.54537 6.5325 2.68931 5.87089 2.97719C5.20927 3.26507 4.63351 3.65396 4.14361 4.14386C3.65371 4.63376 3.26483 5.20951 2.97695 5.87113C2.68907 6.53275 2.54513 7.24234 2.54513 7.99992H1.33301Z"
          fill="#1C1B1F"
        />
      </svg>
      <!-- <HbIcon
        v-if="isPromoPlan"
        mdi-code="mdi-currency-usd"
        small
        color="black"
      /> -->
      <!-- <HbIcon v-else mdi-code="mdi-sale" small color="black" /> -->
      <HbIcon v-else mdi-code="mdi-tag" small color="black" />
    </span>
    <span class="hb-tooltip-dashed">{{ cellValue.name }}</span>
  </div>
  <div v-else>
    <span>No Promotion</span>
  </div>
</template>
<style lang="scss" scoped>
.hb-tooltip-dashed {
  border-bottom: thin dashed;
}
</style>
